import { render, staticRenderFns } from "./_MaterialsList.vue?vue&type=template&id=f01b5c9c&"
import script from "./_MaterialsList.vue?vue&type=script&lang=js&"
export * from "./_MaterialsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports